module.exports = __webpack_public_path__ + "static/media/space-gif3.3dcfc44b.gif";